// extracted by mini-css-extract-plugin
module.exports = {"title":"Date_title__3tnt4"};